import React from 'react';

// Custom Mystical Alchemy Icons for The Belonging Sessions
// These replace standard emojis with premium, themed SVG icons

export const SpiralIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M12 12c0-1.5 1.5-3 3-3s3 1.5 3 3c0 2.5-2 4.5-4.5 4.5S9 14.5 9 12c0-3.5 3-6.5 6.5-6.5S22 8.5 22 12c0 5-4.5 9-9.5 9S3 16.5 3 12c0-6 5-10.5 10.5-10.5" />
  </svg>
);

export const StarburstIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="12" r="3" />
    <line x1="12" y1="2" x2="12" y2="6" />
    <line x1="12" y1="18" x2="12" y2="22" />
    <line x1="2" y1="12" x2="6" y2="12" />
    <line x1="18" y1="12" x2="22" y2="12" />
    <line x1="4.93" y1="4.93" x2="7.76" y2="7.76" />
    <line x1="16.24" y1="16.24" x2="19.07" y2="19.07" />
    <line x1="4.93" y1="19.07" x2="7.76" y2="16.24" />
    <line x1="16.24" y1="7.76" x2="19.07" y2="4.93" />
  </svg>
);

export const FlameIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M12 22c-4 0-7-3-7-7 0-2 1-4 2-5.5.5-.8 1-1.5 1.5-2.5.3-.6.5-1.2.5-2 0 0 2 2 2 4 0 .5-.1 1-.3 1.5 1-.5 2-1.5 2.3-3 .5-2 .5-3.5 0-5.5 3 1.5 6 5 6 10 0 4-3 7-7 7z" />
    <path d="M12 22c-2 0-3.5-1.5-3.5-3.5 0-1 .5-2 1-2.5.3-.3.5-.6.5-1 0 0 .7.7.7 1.4 0 .2 0 .4-.1.6.4-.2.8-.6.9-1.2.2-.8.2-1.4 0-2.2 1.2.6 2.5 2 2.5 4 0 2-1.5 3.5-3.5 3.5z" fill="currentColor" opacity="0.3" />
  </svg>
);

export const EyeOfWisdomIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M12 5c-7 0-10 7-10 7s3 7 10 7 10-7 10-7-3-7-10-7z" />
    <circle cx="12" cy="12" r="3" />
    <circle cx="12" cy="12" r="1" fill="currentColor" />
    <path d="M12 5V3" />
    <path d="M12 21v-2" />
  </svg>
);

export const GlyphIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M12 2L8 8l-6 1 4.5 4-1 6 6.5-3.5 6.5 3.5-1-6 4.5-4-6-1-4-6z" />
    <circle cx="12" cy="12" r="2" fill="currentColor" opacity="0.4" />
  </svg>
);

export const CrystalIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M12 2L6 8v8l6 6 6-6V8l-6-6z" />
    <path d="M6 8l6 6 6-6" />
    <path d="M12 14v8" />
  </svg>
);

export const LotusIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M12 22c0-4 2-6 2-10s-2-6-2-6-2 2-2 6 2 6 2 10" />
    <path d="M12 22c-3-2-5-4-5-8 0-2 1-4 2-5" fill="none" />
    <path d="M12 22c3-2 5-4 5-8 0-2-1-4-2-5" fill="none" />
    <path d="M4 14c1 0 3-1 4-3" />
    <path d="M20 14c-1 0-3-1-4-3" />
    <circle cx="12" cy="8" r="2" fill="currentColor" opacity="0.3" />
  </svg>
);

export const InfinityAlchemyIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M12 12c-2-2.5-4-4-6-4-3 0-4 2-4 4s1 4 4 4c2 0 4-1.5 6-4" />
    <path d="M12 12c2 2.5 4 4 6 4 3 0 4-2 4-4s-1-4-4-4c-2 0-4 1.5-6 4" />
    <circle cx="12" cy="12" r="1.5" fill="currentColor" />
  </svg>
);

export const HeartAlchemyIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M12 21l-1.5-1.3C5.4 15.4 2 12.3 2 8.5 2 5.4 4.4 3 7.5 3c1.7 0 3.4.8 4.5 2.1C13.1 3.8 14.8 3 16.5 3 19.6 3 22 5.4 22 8.5c0 3.8-3.4 6.9-8.5 11.2L12 21z" />
    <path d="M12 7v6" />
    <path d="M9 10h6" />
  </svg>
);

export const MoonPhaseIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M12 3a9 9 0 1 0 9 9c0-.5 0-1-.1-1.5A5.5 5.5 0 0 1 13.5 3.1c-.5-.1-1-.1-1.5-.1z" />
    <circle cx="8" cy="10" r="1" fill="currentColor" />
    <circle cx="10" cy="14" r="0.5" fill="currentColor" />
  </svg>
);

export const CauldronIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <ellipse cx="12" cy="10" rx="8" ry="4" />
    <path d="M4 10c0 6 3.6 10 8 10s8-4 8-10" />
    <path d="M6 20l-2 2" />
    <path d="M18 20l2 2" />
    <path d="M9 6c0-2 1.5-4 3-4s3 2 3 4" />
    <path d="M10 8c.5-1 1-1.5 2-1.5s1.5.5 2 1.5" opacity="0.5" />
  </svg>
);

export const CompassIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="12" r="9" />
    <polygon points="16.24,7.76 14.12,14.12 7.76,16.24 9.88,9.88" fill="currentColor" opacity="0.2" />
    <polygon points="16.24,7.76 14.12,14.12 7.76,16.24 9.88,9.88" />
    <circle cx="12" cy="12" r="1" fill="currentColor" />
  </svg>
);

export const TriangleAlchemyIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M12 3L2 21h20L12 3z" />
    <circle cx="12" cy="14" r="2" />
    <path d="M12 8v4" />
  </svg>
);

export const ScrollIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M8 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h3" />
    <path d="M16 3h3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-3" />
    <path d="M8 3c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2" />
    <path d="M8 21c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2" />
    <path d="M8 11h8" />
    <path d="M8 15h5" />
  </svg>
);

export const QuizGameIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <path d="M9 9h.01" />
    <path d="M15 9h.01" />
    <path d="M9 15h.01" />
    <path d="M15 15h.01" />
    <circle cx="12" cy="12" r="1" fill="currentColor" />
  </svg>
);

export const LightbulbAlchemyIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M9 18h6" />
    <path d="M10 22h4" />
    <path d="M12 2a7 7 0 0 0-5 12c.6.6 1 1.4 1 2.3V17h8v-.7c0-.9.4-1.7 1-2.3A7 7 0 0 0 12 2z" />
    <path d="M12 6v4" />
    <path d="M10 8h4" />
  </svg>
);

export const CameraLensIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="12" r="9" />
    <circle cx="12" cy="12" r="5" />
    <circle cx="12" cy="12" r="2" fill="currentColor" opacity="0.3" />
    <path d="M12 3v2" />
    <path d="M12 19v2" />
    <path d="M3 12h2" />
    <path d="M19 12h2" />
  </svg>
);

export const FeatherQuillIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z" />
    <line x1="16" y1="8" x2="2" y2="22" />
    <line x1="17.5" y1="15" x2="9" y2="15" />
  </svg>
);

export const CheckAlchemyIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M9 12l2 2 4-4" />
  </svg>
);

export const CrossAlchemyIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M15 9l-6 6" />
    <path d="M9 9l6 6" />
  </svg>
);

// BlissAbode - Sacred Sanctuary/Home Icon
export const SanctuaryIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    {/* Sacred temple/home shape */}
    <path d="M12 2L2 9h3v11h14V9h3L12 2z" />
    {/* Inner sanctuary circle */}
    <circle cx="12" cy="13" r="3" />
    {/* Light rays from center */}
    <path d="M12 7v3" />
    <path d="M9.5 10.5L12 13" />
    <path d="M14.5 10.5L12 13" />
    {/* Peaceful door */}
    <path d="M10 20v-4h4v4" />
  </svg>
);

// Icon mapping for easy replacement
export const AlchemyIconMap = {
  quiz: QuizGameIcon,
  game: QuizGameIcon,
  lightbulb: LightbulbAlchemyIcon,
  idea: LightbulbAlchemyIcon,
  camera: CameraLensIcon,
  eye: EyeOfWisdomIcon,
  observation: CameraLensIcon,
  feeling: HeartAlchemyIcon,
  heart: HeartAlchemyIcon,
  need: LotusIcon,
  flower: LotusIcon,
  request: FeatherQuillIcon,
  write: FeatherQuillIcon,
  check: CheckAlchemyIcon,
  correct: CheckAlchemyIcon,
  cross: CrossAlchemyIcon,
  wrong: CrossAlchemyIcon,
  flame: FlameIcon,
  fire: FlameIcon,
  spiral: SpiralIcon,
  journey: SpiralIcon,
  star: StarburstIcon,
  crystal: CrystalIcon,
  glyph: GlyphIcon,
  moon: MoonPhaseIcon,
  cauldron: CauldronIcon,
  compass: CompassIcon,
  triangle: TriangleAlchemyIcon,
  scroll: ScrollIcon,
  infinity: InfinityAlchemyIcon,
};

export default AlchemyIconMap;
